import { createContext, Dispatch, SetStateAction, useContext, useLayoutEffect } from 'react';
import { useViewportSize } from '@ff-os/shared-react/hooks/useViewportSize';

type OrientationContext = {
    orientation: Orientations;
    setOrientation: Dispatch<SetStateAction<Orientations>>;
};

export type Orientations = 'portrait' | 'landscape';
export const Orientation = createContext<OrientationContext>({
    orientation: 'portrait',
    setOrientation: () => {}
});

export const useOrientation = (orientation: Orientations | 'screen' = 'screen') => {

    const { setOrientation } = useContext(Orientation);
    const { width, height } = useViewportSize();

    useLayoutEffect(() => {
        if (orientation === 'screen') {
            setOrientation(width / height < 1 ? 'portrait' : 'landscape');
        } else {
            setOrientation(orientation);
        }
    });
};